import React from 'react';
import PropTypes from 'prop-types';

import { RecordPage, recordingPages } from 'Pages/RecordPage';
import { Button, useConfirmationModal } from 'LocalGluons';
import { useRecordings } from 'LocalGluons/components/RecordingsContext/RecordingsContext';
import { t } from 'Locale';

import { getRecordingForItem, getRecordingStatus, RECORDING_STATUS } from 'Utils/itemUtils';
import { Device } from 'DeviceUtils';
import detailStyles from '../../Details.jss';
import { useAppErrorHandler } from '../../../../App/AppErrorHandlerContext/AppErrorHandlerContext';

const RecordingButton = ({ navigation, item, updateItem }) => {
    const { setModalContent } = useConfirmationModal();
    const { setError } = useAppErrorHandler();
    const { updateRecordings } = useRecordings();

    const onRecordPageClose = (closeParent = false) => {
        setModalContent(null);
        if (closeParent === true) navigation.pop();
    };

    const onRecordStateChanged = () => {
        updateItem(true);
        updateRecordings();
    };

    const onRecordPress = (page) => {
        setModalContent(
            <RecordPage
                width={Device.isTabletOrWeb ? 400 : undefined}
                page={page}
                item={item}
                onClose={onRecordPageClose}
                onRecordStateChanged={onRecordStateChanged}
                setError={setError}
                setModalContent={setModalContent}
            />
        );
    };

    const getButtonProps = () => {
        const { data } = getRecordingForItem(item);
        const isSimple = data?.type === 'SIMPLE';
        switch (getRecordingStatus(item)) {
            case RECORDING_STATUS.PLANNED:
                return {
                    iconName: 'player_record',
                    title: t('RECORDINGS.BTN_CANCEL_RECORDING'),
                    onPress: onRecordPress.bind(
                        this,
                        isSimple
                            ? recordingPages.cancelRecordingsSimple
                            : recordingPages.cancelRecordings
                    )
                };
            case RECORDING_STATUS.ARCHIVED:
            case RECORDING_STATUS.DONE:
                return {
                    iconName: 'record_delete',
                    title: t('RECORDINGS.DELETE_RECORDING'),
                    onPress: onRecordPress.bind(
                        this,
                        isSimple
                            ? recordingPages.deleteRecordingSimple
                            : recordingPages.deleteRecordings
                    )
                };
            default:
                return {
                    iconName: 'player_record',
                    title: t('RECORDINGS.TO_RECORD'),
                    onPress: onRecordPress.bind(
                        this,
                        item.isSeries()
                            ? recordingPages.setRecordings
                            : recordingPages.setRecordingsSimple
                    )
                };
        }
    };

    return (
        <Button
            style={{
                button: detailStyles.button
            }}
            isSecondary
            {...getButtonProps()}
        />
    );
};

RecordingButton.defaultProps = {
    parentItem: null
};

RecordingButton.propTypes = {
    navigation: PropTypes.shape({}).isRequired,
    item: PropTypes.shape({}).isRequired,
    onLoading: PropTypes.func.isRequired,
    updateItem: PropTypes.func.isRequired,
    parentItem: PropTypes.shape({})
};

export default RecordingButton;
